import { c as _c } from "react/compiler-runtime";
import { type RouterOutputs } from '../../utils/trpc';
import Avatar from '../common/Avatar';
import AwardBadges from './AwardBadges';
const AwardListitem = props => {
  const $ = _c(24);
  const {
    user,
    awards,
    totalTrons,
    awardCount
  } = props;
  let t0;
  if ($[0] !== awards) {
    t0 = Object.values(awards.reduce(_temp, {})).sort(_temp2);
    $[0] = awards;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tiers = t0;
  const t1 = user.tag === "BOT";
  let t2;
  if ($[2] !== t1 || $[3] !== user.avatarKey || $[4] !== user.robohash || $[5] !== user.userId) {
    t2 = <div className="shrink-0"><Avatar avatarKey={user.avatarKey} robohash={user.robohash} isBot={t1} userId={user.userId} size={35} /></div>;
    $[2] = t1;
    $[3] = user.avatarKey;
    $[4] = user.robohash;
    $[5] = user.userId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== user.name || $[8] !== user.username) {
    t3 = <p className="truncate font-semibold">{user.name ? <>{user.name}<span className="font-normal text-textSecondary">{" "}@{user.username}</span></> : <>@{user.username}</>}</p>;
    $[7] = user.name;
    $[8] = user.username;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== totalTrons) {
    t4 = totalTrons.toLocaleString();
    $[10] = totalTrons;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = awardCount > 1 && ` · ${awardCount} awards`;
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <p className="truncate text-sm text-textSecondary">{t4} trons{t5}</p>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t6) {
    t7 = <div className="min-w-0 flex-1">{t3}{t6}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== tiers) {
    t8 = <div className="shrink-0"><AwardBadges tiers={tiers} size="md" /></div>;
    $[18] = tiers;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t2 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className="flex items-center gap-3 rounded-md p-3 transition-all duration-200 ease-in-out hover:bg-background-light">{t2}{t7}{t8}</div>;
    $[20] = t2;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default AwardListitem;
function _temp(acc, a) {
  if (acc[a.title]) {
    acc[a.title].count = acc[a.title].count + 1;
  } else {
    acc[a.title] = {
      image: a.image,
      title: a.title,
      count: 1,
      quantity: a.quantity
    };
  }
  return acc;
}
function _temp2(a_0, b) {
  return b.quantity - a_0.quantity;
}